import React, { useEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';
import Button, { ButtonType, ButtonTheme,ButtonSize } from '../../atoms/button/button';
import './formPopup.scss';
import Icon, { IconType, IconSize } from '../../atoms/icon/icon';

const FormPopupFooter = (props) => {
  const {
    onClose,onSave,onEdit,id,mode,onSecondary,
  } = props;
  return (
    <div style={{width:'100%'}}>
      <div style={{float:'left'}}>
        <Button
          id={`button-cancel`}
          type={'button'}
          onClick={() => onClose()}
          theme={ButtonTheme.SECONDARY}
        >
          Cancel
        </Button>
      </div>
      {mode=="new" && <div style={{float:'right'}}>
        <Button
          id={`button-save`}
          type={'submit'}
          onClick={() => onSave()}
          theme={ButtonTheme.PRIMARY}
        >
          Save
        </Button>
      </div>}
      {mode=="edit" && <div style={{float:'right'}}>
        <Button
          id={`button-save`}
          type={'submit'}
          onClick={() => onEdit()}
          theme={ButtonTheme.PRIMARY}
        >
          Update
        </Button>
      </div>}
      {mode=="secondary" && <div style={{float:'right'}}>
        <Button
          id={`button-save`}
          type={'submit'}
          onClick={() => onSecondary()}
          theme={ButtonTheme.PRIMARY}
        >
          Update
        </Button>
      </div>}
    </div>
  );
};

FormPopupFooter.propTypes = {
  id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  onClose: PropTypes.func,
  onSave:PropTypes.func,
  theme: PropTypes.oneOf(Object.values(ButtonTheme)),
  /**
   * Button general size
   */
  size: PropTypes.oneOf(Object.values(ButtonSize)),
};

FormPopupFooter.defaultProps = {
  onClose: () => {},
  onSave: () => {},
};

export default FormPopupFooter;
